import { type HTMLAttributes, type Ref } from "react"
import { cn } from "cn"

export function CardGrid({
  ref,
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div ref={ref} className={cn("@container/card-grid", className)} {...props}>
      <ul className="my-[calc(var(--card-gap-y)/2*-1)] grid grid-cols-[repeat(auto-fill,minmax(var(--card-w),1fr))] gap-x-(--card-gap-x) [--card-gap-x:theme(space.4)] [--card-gap-y:theme(space.8)] [--card-w:10rem] *:grid *:grid-rows-subgrid *:py-[calc(var(--card-gap-y)/2)] @lg/card-grid:[--card-gap-x:theme(space.6)] @lg/card-grid:[--card-gap-y:theme(space.10)] @lg/card-grid:[--card-w:14rem]">
        {children}
      </ul>
    </div>
  )
}

CardGrid.displayName = "CardGrid"
